// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__1CH6Y","noInteraction":"EventWrapper_noInteraction__9d6iF","pointerPassthrough":"EventWrapper_pointerPassthrough__3pR3p"};